import { useField } from "formik";
import moment from "moment";
import { Grid, Message } from "semantic-ui-react";
import { FormDateInput } from "./Form";
import React from "react";

export const ChangeDateInput = () => {
  const [field] = useField("change_date");

  const dateTooFar = () => {
    const selectedDate = moment(field.value);

    return Math.abs(selectedDate.diff(moment(), "weeks")) >= 2;
  };

  return (
    <Grid.Row>
      <Grid.Column width={6}>
        <FormDateInput label="Data da mudança" name="change_date" />
      </Grid.Column>
      <Grid.Column width={10}>
        <Message warning visible={dateTooFar()}>
          <Message.Header>Atenção!</Message.Header>
          <Message.Content>
            A data escolhida está a mais de duas semanas da data atual.
          </Message.Content>
        </Message>
      </Grid.Column>
    </Grid.Row>
  );
};
